import { MINCOL } from "../../../constants/const";

export const strKatHeader = [
{accessor: 'id',
Header: 'ID'},
{accessor: 'kategorie',
Header: 'Streckenkategorie',
width: MINCOL},
{accessor: 'bemerkung',
Header: 'Beschreibung',
width: '27em'},
];

export const strKatForm = [
    {accessor: 'kategorie',
    Header: 'Streckenkategorie'},
    {accessor: 'bemerkung',
    Header: 'Beschreibung'},
];